var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.alert)?_c('v-app-bar',{attrs:{"color":_vm.alert.type,"dark":"","app":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.alert.message))])],1):_vm._e(),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }